export var AccountViewTypes;
(function (AccountViewTypes) {
    AccountViewTypes["NORMAL"] = "NORMAL_ACCOUNT";
    AccountViewTypes["CREDIT"] = "CREDIT_ACCOUNT";
    AccountViewTypes["BSU"] = "BSU_ACCOUNT";
})(AccountViewTypes || (AccountViewTypes = {}));
export var BsuDisplay;
(function (BsuDisplay) {
    BsuDisplay["YEARLY"] = "YEARLY";
    BsuDisplay["TOTAL"] = "TOTAL";
})(BsuDisplay || (BsuDisplay = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWNjb3VudFZpZXdUeXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FjY291bnRWaWV3L0FjY291bnRWaWV3VHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFOLElBQVksZ0JBSVg7QUFKRCxXQUFZLGdCQUFnQjtJQUN4Qiw2Q0FBeUIsQ0FBQTtJQUN6Qiw2Q0FBeUIsQ0FBQTtJQUN6Qix1Q0FBbUIsQ0FBQTtBQUN2QixDQUFDLEVBSlcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQUkzQjtBQUVELE1BQU0sQ0FBTixJQUFZLFVBR1g7QUFIRCxXQUFZLFVBQVU7SUFDbEIsK0JBQWlCLENBQUE7SUFDakIsNkJBQWUsQ0FBQTtBQUNuQixDQUFDLEVBSFcsVUFBVSxLQUFWLFVBQVUsUUFHckIifQ==